<template>
    <default-template>
        <v-container>
            <slot />
        </v-container>

        <template slot="fab" slot-scope="{showScroll, scrollTo}">
            <slot name="fab" v-bind:showScroll="showScroll" v-bind:scrollTo="scrollTo">
            </slot>
        </template>
    </default-template>
</template>
<script>
import DefaultTemplate from "../DefaultTemplate.vue";
export default {
    components: {
        DefaultTemplate
    }
}
</script>